import { ApisauceInstance, create } from 'apisauce';

interface ApiProps extends ApisauceInstance {
    clearTokenInfo: () => void;
    setDeviceInfo?: (data: {
        device: string;
        ip: string;
        os: string;
        appVersion: string;
    }) => void;
}

export const publicApi = create({
    baseURL: '/v1',
}) as ApiProps;

publicApi.setDeviceInfo = ({ device, ip, os, appVersion }) => {
    publicApi.setHeaders({
        Device: device,
        IP: ip,
        OS: os,
        'X-App-Version': appVersion,
    });
};
